/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.63   Rana simulation core release: 3.7.3   deployed on:  08:32AM (UTC) on September 25, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { UsePreconditionerCgEnum } from "./UsePreconditionerCgEnum";
import {
  UsePreconditionerCgEnumFromJSON,
  UsePreconditionerCgEnumFromJSONTyped,
  UsePreconditionerCgEnumToJSON,
  UsePreconditionerCgEnumToJSONTyped,
} from "./UsePreconditionerCgEnum";

/**
 * A type of `ModelSerializer` that uses
 * hyperlinked relationships with compound keys instead
 * of primary key relationships.  Specifically:
 * * A 'url' field is included instead of the 'id' field.
 * * Relationships to other instances are hyperlinks, instead of primary keys.
 * NOTE: this only works with DRF 3.1.0 and above.
 * @export
 * @interface PatchedSubstance
 */
export interface PatchedSubstance {
  /**
   * Try to build the URL to this substance, given the simulation in the request.
   */
  readonly url?: string | null;
  /**
   *
   */
  name?: string;
  /**
   *
   */
  readonly id?: number;
  /**
   * The diffusion coefficient (m2/s) for the substance.
   */
  diffusionCoefficient?: number;
  /**
   * The growth coefficient for the substance.
   */
  growthCoefficient?: number;
  /**
   * The decay coefficient for the substance.
   */
  decayCoefficient?: number;
  /**
   * The numerical diffusion limiter for the substance.
   *  Options:
   * 0 = off
   * 1 = standard
   *
   *
   * * `0` - off
   * * `1` - standard
   */
  numericalDiffusionLimiter?: UsePreconditionerCgEnum;
  /**
   * The units of the substance.
   */
  units?: string;
  /**
   *
   */
  readonly uid?: string;
}

/**
 * Check if a given object implements the PatchedSubstance interface.
 */
export function instanceOfPatchedSubstance(value: object): value is PatchedSubstance {
  return true;
}

export function PatchedSubstanceFromJSON(json: any): PatchedSubstance {
  return PatchedSubstanceFromJSONTyped(json, false);
}

export function PatchedSubstanceFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PatchedSubstance {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"] === undefined ? undefined : json["url"] === null ? null : json["url"],
    name: json["name"] == null ? undefined : json["name"],
    id: json["id"] == null ? undefined : json["id"],
    diffusionCoefficient:
      json["diffusion_coefficient"] == null ? undefined : json["diffusion_coefficient"],
    growthCoefficient: json["growth_coefficient"] == null ? undefined : json["growth_coefficient"],
    decayCoefficient: json["decay_coefficient"] == null ? undefined : json["decay_coefficient"],
    numericalDiffusionLimiter:
      json["numerical_diffusion_limiter"] == null
        ? undefined
        : UsePreconditionerCgEnumFromJSON(json["numerical_diffusion_limiter"]),
    units: json["units"] == null ? undefined : json["units"],
    uid: json["uid"] == null ? undefined : json["uid"],
  };
}

export function PatchedSubstanceToJSON(json: any): PatchedSubstance {
  return PatchedSubstanceToJSONTyped(json, false);
}

export function PatchedSubstanceToJSONTyped(
  value?: Omit<PatchedSubstance, "url" | "id" | "uid"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    name: value["name"],
    diffusion_coefficient: value["diffusionCoefficient"],
    growth_coefficient: value["growthCoefficient"],
    decay_coefficient: value["decayCoefficient"],
    numerical_diffusion_limiter: UsePreconditionerCgEnumToJSON(value["numericalDiffusionLimiter"]),
    units: value["units"],
  };
}
